module.exports = __webpack_public_path__ + "static/media/bariatric-ctc-fs-new-lumbar.106c1898.png";